import { render, staticRenderFns } from "./LanguagesTab.vue?vue&type=template&id=c122f120&scoped=true&"
import script from "./LanguagesTab.vue?vue&type=script&lang=ts&"
export * from "./LanguagesTab.vue?vue&type=script&lang=ts&"
import style0 from "./LanguagesTab.vue?vue&type=style&index=0&id=c122f120&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c122f120",
  null
  
)

export default component.exports